module.exports = __webpack_public_path__ + "img/4A.6323af18.jpeg";